import { useEffect, useState } from 'react';

import './style.scss';

import logo from '../../assets/images/logo/etown_logo.png';

const LoadingImage = (props) => {
  const { isApiLoaded, onClosing, onClosed, onStarted } = props;
  const loadingImage = logo;
  const [enabled, setEnabled] = useState(true);
  const [enableAnimation, setEnabledAnimation] = useState(false);
  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  useEffect(() => {
    // fire onStarted after 3s from mount
    const startedTimer = setTimeout(() => {
      onStarted && onStarted();
    }, 3000);

    return () => clearTimeout(startedTimer);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (isApiLoaded) {
      (async () => {
        setEnabledAnimation(true);
        await delay(2000); // fade-out animation duration
        onClosing && onClosing();
        setEnabled(false);
        onClosed && onClosed();
        window.logMessage('Loading image closed');
      })();
    }
    // eslint-disable-next-line
  }, [isApiLoaded]);

  // const progress = useRef(0);
  // const progressEl = useRef(null);

  // useEffect(() => {
  //   const updateProgress = () => {
  //     const el = progressEl.current;
  //     if (el) {
  //       el.style.width = `${progress.current}%`;
  //     }
  //   };

  //   const timer = setInterval(() => {
  //     if (progress.current < 100) {
  //       progress.current += 1;
  //       updateProgress();
  //     } else {
  //       setProgressComplete(true);
  //       clearInterval(timer);
  //     }
  //   }, 30); // 40ms * 100 = 4000ms = 4s

  //   return () => clearInterval(timer);
  // }, []);

  return (
    <>
      {enabled ? (
        <div
          className={`loading-container ${enableAnimation ? 'fade-out' : ''}`}
        >
          <div className="loading-image">
            <img src={loadingImage} alt="Loading intro" />
          </div>
        </div>
      ) : null}
    </>
  );
};

export default LoadingImage;
